import { amplitude, ga } from 'js/analytics/adapters'
import { baseWebEventProps, webpageProps } from 'js/analytics/standardizedProps'

export const trackRegistrationMethod = ({ method }) => {
  ga.track('choose_registration_method', { registration_method: method })
  // Stays on user_start_registration, marked with
  // interaction_type 'method_selection' (vs 'cta' on trackStartRegistration)
  // so the two are countable separately. authentication_method carries which
  // method was chosen.
  amplitude.track('user_start_registration', {
    ...baseWebEventProps(),
    ...webpageProps(),
    action_name: 'start',
    action_type: 'active',
    interaction_type: 'method_selection',
    authentication_method: method,
  })
}
